export default __webpack_public_path__ + "static/media/3-Cloudxier-CSR-Report-Pertamina.f070f864.jpg";